import { IDonorConnect } from '@nkr/models/index';
import { Button, Label, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IDonorConnect,
    onConfirm: () => void,
    onCancel: () => void
}

const DonationDateConfirmation = (props: IProps) => {
    let id = props.data != null ? props.data.id : '';
    let donationDate = props.data != null ? props.data.mentorDonationDate : '';
    let centerAlias = props.data != null ? props.data.centerAlias : '';
    let firstName = props.data != null ? props.data.firstName : '';
    let lastName = props.data != null ? props.data.lastName : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Donation Date for <Label bsStyle='success'>{id}</Label> at {centerAlias}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>Are you sure you wish to mark <b>{firstName} {lastName}</b> as donated on <Label>{donationDate}</Label> </span>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Save Donation Date</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DonationDateConfirmation;